import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { ISubmissionFile } from '@publishing-engine/domain/models/submission';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FormFieldFileUploadArray } from '@publishing-engine/domain/types/article.js';
import { FileListDisplay } from './FileListDisplay.js';

interface Props {
  value?: ISubmissionFile[];
  previousValue?: ISubmissionFile[];
  onClose: () => void;
  config: Omit<FormFieldFileUploadArray, 'component'>;
  submissionContextId?: string;
}

const zeroState = (
  <Flex
    flexDirection="row"
    justifyContent="space-between"
    backgroundColor="surfaceTertiaryFill"
    padding={4}
    color="neutralSecondaryContent"
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <FontAwesomeIcon
        color="neutralSecondaryContent"
        icon={faFile}
        fontSize={32}
      />
      <Text textStyle="textBody">No data available</Text>
    </Flex>
  </Flex>
);

export const FileListDiffModal = ({
  value,
  previousValue,
  onClose,
  config,
  submissionContextId
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = Array.isArray(previousValue) && previousValue.length > 0;
  const hasCurrent = Array.isArray(value) && value.length > 0;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {!hasPrevious ? (
          zeroState
        ) : (
          <FileListDisplay files={previousValue} filenameDisplay="fileName" submissionContextId={submissionContextId} />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {!hasCurrent ? (
          zeroState
        ) : (
          <FileListDisplay files={value} filenameDisplay="fileName" submissionContextId={submissionContextId}  />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
